module.exports = __webpack_public_path__ + "static/media/QR_Code_.49a888c1.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/QR_Code_.png
// module id = 397
// module chunks = 1